import { AnyAction } from 'redux';
import { ILoadingError } from '#/types/global';
import { IArtistAlbums, IArtistResponse } from '#/types/API/artists';
import { ITrackWithFavorite } from './artist';
import {
  createActionTrackReset,
  createActionTrackSetAlbumTrackFavorite,
  createActionTrackSetDetails,
  createActionTrackSetError,
  createActionTrackSetFavorite,
  createActionTrackSetTopTrackFavorite,
  createActionTrackStartLoading,
  createActionTrackStopLoading,
} from '../actions/track';
import { IAlbums } from './artistAlbums';

export interface ITrackState {
  artist?: IArtistResponse;
  track?: ITrackWithFavorite;
  album?: IAlbums;
  otherAlbums?: IArtistAlbums['items'];
  topTracks?: ITrackWithFavorite[];
  relatedArtists?: IArtistResponse[];
}

type TState = ITrackState & ILoadingError;

const initialState: TState = {
  _loading: true,
  _error: false,
};

const track = (state: TState = initialState, action: AnyAction): TState => {
  if (createActionTrackSetDetails.doesMatch(action)) {
    return { ...state, ...action.payload };
  }

  if (createActionTrackStartLoading.doesMatch(action)) {
    return { ...state, _loading: true };
  }

  if (createActionTrackStopLoading.doesMatch(action)) {
    return { ...state, _loading: false };
  }

  if (createActionTrackSetError.doesMatch(action)) {
    return { ...state, _error: action.payload };
  }

  if (createActionTrackSetFavorite.doesMatch(action)) {
    if (state.track) {
      return {
        ...state,
        track: { ...state.track, favorite: action.payload.favorite },
      };
    }
    return state;
  }

  if (createActionTrackSetTopTrackFavorite.doesMatch(action)) {
    if (state.topTracks) {
      const newTopTracks = [...state.topTracks];
      const indexTopTrack = newTopTracks.findIndex(
        (topTrack) => topTrack.id === action.payload.track
      );
      if (indexTopTrack !== -1) {
        newTopTracks[indexTopTrack].favorite = action.payload.favorite;
        return {
          ...state,
          topTracks: newTopTracks,
        };
      }
    }
    return state;
  }

  if (createActionTrackSetAlbumTrackFavorite.doesMatch(action)) {
    if (state.album) {
      const newAlbumTracks = [...state.album.tracks.items];
      const indexAlbumTrack = newAlbumTracks.findIndex(
        (albumTrack) => albumTrack.id === action.payload.track
      );
      if (indexAlbumTrack !== -1) {
        newAlbumTracks[indexAlbumTrack].favorite = action.payload.favorite;
        return {
          ...state,
          album: {
            ...state.album,
            tracks: { ...state.album.tracks, items: newAlbumTracks },
          },
        };
      }
    }
    return state;
  }

  if (createActionTrackReset.doesMatch(action)) {
    return initialState;
  }

  return state;
};

export default track;
